import { cn, paragraph, title } from "@dalmatech/ui"

const container = cn("relative w-full z-30 fixed")
const root = cn(
  "flex w-full items-center justify-center gap-6 bg-white p-4 lg:h-20 lg:px-12 lg:py-2 lg:border-b lg:border-neutral-200"
)
const rootNoBorder = cn(
  "flex w-full items-center justify-center gap-6 bg-white p-4 lg:h-20 lg:px-12 lg:py-2"
)
const navbar = cn("flex w-full max-w-[84rem] items-center justify-between relative")
const logoLink = cn(
  "inline-flex focus-visible:rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blurple-600 focus-visible:ring-offset-4"
)
const skeleton = cn("h-6 w-full mx-auto max-w-[42.75rem] hidden lg:block")
const callButton = cn("shrink-0")
const mobileCallButton = cn("flex-nowrap w-10 z-40 ")
const cartAndCallButtonContainer = cn("flex items-center gap-2")
const reservedSpace = cn("flex flex-col justify-center")
const breadcrumb = cn("hidden lg:flex")
const wrapperButton = cn("flex justify-end")
const mobilePopUp = cn("bg-blurple-500 absolute left-0 top-12 rounded-xl w-full p-3")
const popUp = (isPopUpDesktopOpen: boolean) =>
  cn(
    "bg-blurple-500 fixed z-60 right-6 top-[6rem] rounded-xl w-96 py-4 px-6",
    isPopUpDesktopOpen ? "" : "pointer-events-none"
  )
const contentPopUp = cn("flex items-start relative")
const contentTextPopUp = cn("ml-1 pr-10 mb-2")
const titlePopUp = cn(title({ size: "sm", className: "text-sm text-white font-bold mb-1" }))
const descriptionPopUp = cn(paragraph({ size: "sm", className: "text-neutral-100" }))
const mobileDescriptionPopUp = cn(paragraph({ size: "sm", className: "text-neutral-100" }))
const popUpButton = cn("w-full mt-2")
const loading = cn("h-full w-full animate-pulse rounded-lg bg-neutral-100")
const iframe = cn("h-full w-full")
const containerBackButton = cn("absolute top-24 left-0")
const backButton = cn("bg-neutral-50 hover:bg-neutral-100 border-0")
const progressBar = cn("flex items-center w-full bg-white")
const completedStepsBar = cn("h-[2px] bg-gradient-to-r from-blurple-500 to-blurple-900")
const uncompletedStepsBar = cn("h-[2px] bg-neutral-100 w-full flex-1")
const activeStep = cn("bg-neutral-25 w-3 h-3 rounded-full flex items-center justify-center")
const activeStepIndicator = cn("bg-black w-[6px] h-[6px] rounded-full")

export { activeStep, activeStepIndicator, backButton, breadcrumb, callButton, cartAndCallButtonContainer, completedStepsBar, container, containerBackButton, contentPopUp, contentTextPopUp, descriptionPopUp, iframe, loading, logoLink, mobileCallButton, mobileDescriptionPopUp, mobilePopUp, navbar, popUp, popUpButton, progressBar, reservedSpace, root, rootNoBorder, skeleton, titlePopUp, uncompletedStepsBar, wrapperButton }
